import React from "react"
import MovingText from "../../../components/MovingTexts/MovingTexts"
import BodyText from "../../../components/text/body-text/body-text"
import { Link } from "gatsby"
import * as styles from './index.module.css';

const NewsSection = () => {
  const newsItems = [
    <div className="relative z-10" key="grpahic">New Course Launch <Link className="text-[#fff]" to="/course/graphic-designing-and-video-editing/">Graphics Designer & Video Editor</Link></div>,
    <div className="relative z-10" key="hospitality">Upcoming course - <Link className="text-[#fff]" to="/course/advanced-diploma-in-hospitality-operations/">Advanced Diploma in Hospitality Operations</Link></div>
  ]

  return (
    <div>
      
      {newsItems.length > 0 && (
        <div className="flex text-center justify-center items-center bg-[linear-gradient(270deg,_#2CCB99_0%,_#45B9CD_47%,_#4FB1E1_100%)]  ">
          <div className="w-[25%] md:w-[30%] lg:w-[14%] bg-[#2D4181] flex justify-center items-center md:gap-2 py-2 px-2 text-white rounded-r-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22.968"
              height="36.201"
              viewBox="0 0 22.968 36.201"
            >
              <g
                id="noun_mike_1689964"
                transform="translate(-698.788 -277.002)"
              >
                <g
                  id="Group_9465"
                  data-name="Group 9465"
                  transform="translate(698.788 277.002)"
                >
                  <path
                    id="Path_24612"
                    data-name="Path 24612"
                    d="M721.031,1008.551H718.9v5.959a8.631,8.631,0,0,1-17.262,0v-5.959h-2.129a.726.726,0,0,0-.724.724v5.235a11.489,11.489,0,0,0,10.76,11.447v5.871h-3.789a.724.724,0,1,0,0,1.448h9.027a.724.724,0,1,0,0-1.448H711v-5.87a11.484,11.484,0,0,0,10.76-11.447v-5.235A.726.726,0,0,0,721.031,1008.551Z"
                    transform="translate(-698.788 -997.075)"
                    fill="#fff"
                  />
                  <path
                    id="Path_24613"
                    data-name="Path 24613"
                    d="M982.9,286.111a.8.8,0,0,0,.869.724h3.541v1.752h-3.541a.736.736,0,1,0,0,1.448h3.541v1.745h-3.541a.736.736,0,1,0,0,1.448h3.541v1.209a7.183,7.183,0,0,1-14.366,0v-1.209h3.519a.74.74,0,1,0,0-1.448h-3.519v-1.745h3.519a.74.74,0,1,0,0-1.448h-3.519v-1.752h3.519a.74.74,0,1,0,0-1.448h-3.519v-1.209a7.183,7.183,0,0,1,14.366,0v1.209h-3.541A.8.8,0,0,0,982.9,286.111Z"
                    transform="translate(-968.642 -277.002)"
                    fill="#fff"
                  />
                </g>
              </g>
            </svg>

            <BodyText variant="bodyText7" className="hidden md:block font-bold px-2">NEWS UPDATE</BodyText>
            <BodyText variant="bodyText7" className="block md:hidden font-bold px-2">NEWS</BodyText>
          </div>
          <div className="w-[75%] md:w-[70%] lg:w-[100%] ">

          <MovingText newsItems={newsItems}  />
          </div>
        </div>
      )}
    </div>
  )
}

export default NewsSection
